const autoNgTemplateLoaderTemplate1 = require('./activity-logs-view.html');

import controller from './activity-logs-view.controller.js';

export const activityLogsView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
